var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasErr)?_c('empty',{attrs:{"text":_vm.text}}):_c('div',{ref:"main",staticClass:"main"},[_c(_vm.moduleId,{tag:"component",attrs:{"info":_vm.enterInfo,"stepNo":_vm.stepNo}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }